module.exports = __webpack_public_path__ + "img/sistemico-3.91c9f7d1.jpg";